import PropTypes from 'prop-types'

/**
 * Finds all nodes in a tree that match the given id.
 * This function should return an array of nodes that match the given id.
 * @param {Object} nodeOrTree - The node or tree to search.
 * @param {string} id - The id to match against.
 * @param {Array} found - An array to store the found nodes.
 * @returns {Array} - An array of nodes that match the given id.
 *
 * @example
 * const nodes = getAllNodeById(ingredientsTree, 'testId')
 */

const getAllNodeById = (nodeOrTree, id, found = []) => {
  // Treat the input as a tree containing multiple root nodes if it's not the initial call
  if (nodeOrTree instanceof Object && !nodeOrTree?._id) {
    Object.values(nodeOrTree).forEach((rootNode) => {
      getAllNodeById(rootNode, id, found)
    })
  } else {
    // The original logic for a single node
    const node = nodeOrTree // For clarity in this context
    if (node?._id === id) {
      found.push(node)
    }
    if (node?.children) {
      Object.values(node?.children).forEach((childNode) => {
        getAllNodeById(childNode, id, found)
      })
    }
  }
  return found
}

getAllNodeById.propTypes = {
  nodeOrTree: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  found: PropTypes.array
}

export default getAllNodeById
